import type { Breakpoint } from "../Breakpoint";

import { transformBreakpointToEmNumber } from "./transformBreakpointToEmNumber";

const nextBreakpointEms = (breakpoint: Breakpoint) => {
    const nextBreakpoint = breakpoint + 1;
    return transformBreakpointToEmNumber(nextBreakpoint);
};

export const transformBreakpointToMediaQuerySpan = (breakpoint: Breakpoint, direction: "down" | "only" | "up") => {
    let mediaQuerySpan: string;
    const breakpointEms = transformBreakpointToEmNumber(breakpoint);

    switch (direction) {
        case "down":
            mediaQuerySpan = `(max-width: ${breakpointEms - 0.00125}em)`;
            break;

        case "only":
            mediaQuerySpan = `(min-width: ${breakpointEms}em) and (max-width: ${
                nextBreakpointEms(breakpoint) - 0.00125
            }em)`;
            break;

        case "up":
        default:
            mediaQuerySpan = `(min-width: ${breakpointEms}em)`;
            break;
    }

    return mediaQuerySpan;
};

export const transformBreakpointToCSSMediaQuery = (breakpoint: Breakpoint, span: "down" | "only" | "up") =>
    `@media ${transformBreakpointToMediaQuerySpan(breakpoint, span)}`;
